var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"modal-pagamentos-aluno","title":"Pagamentos","size":"lg","ok-only":""}},[_c('pagamentos-aluno',{attrs:{"all":true,"pendencias":_vm.pendencias}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }